import * as Yup from 'yup'

import LookupType from './LookupType'

export const DocumentFileSchema = Yup.object().shape({
    document_category: LookupType
        .label('Document Category')
        .default(null)
        .nullable()
        .required(),
    file_data: Yup.mixed(),

    document_tags: Yup.array().of(LookupType),

    job_type_job_category: LookupType
        .label('Project')
        .nullable()
})

export const DocumentUploadSchema = Yup.object().shape({
    job_id: Yup.string().required(),

    document_file_list: Yup.array().of(DocumentFileSchema).required()
})